
import { Pie } from '@ant-design/plots';
import Heading from './Heading';


const PieGraph2 = ({ heading, subheading, M1, M2, M3, M4,Surplus,AVS }) => {
  let slackValue = Number(M1) - Number(M2) - Number(M3) - Number(M4);
  slackValue = slackValue < 0 ? slackValue = null : slackValue;
  Surplus=Number(Surplus)?Surplus:0
  AVS=Number(AVS)?AVS:0
  const data = [
    {
      type: "Surplus",
      value: Number(Surplus),
    },
    {
      type: "Amount available for Value Spending",
      value: Number(AVS),
    },
  

  ];

  const config = {
    appendPadding: 10,
    data,
    angleField: 'value',
    colorField: 'type',
    color: ['#FF7A00', '#404EED'],
    radius: 0.75,
    label: {
      type: 'spider',
      labelHeight: 28,
      content: '{name} \n {percentage} ({value})',
    },
    interactions: [
      {
        type: 'element-selected',
      },
      {
        type: 'element-active',
      },
    ],
  };
  return (
    <div className='space-y-4 justify-center'>
      
        <Heading text={heading} classes={'md:w-2/4 '}/>
      {
        subheading &&
        <div className='flex justify-center'>
          <h2 className='bg-primary/10 text-primary rounded-xl py-2 px-2 text-base md:text-xl w-72 text-center'>{subheading}</h2>
        </div>
      }
      <Pie {...config}/>
    </div>
  );
};

export default PieGraph2;